import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../stores';
import OrderDialog from './components/order/OrderDialog';
import OrderEditDialog from './components/order/EditOrderDialog';
import EditFolderDialog from './components/training/EditFolderDialog';
import EditTrainingDialog from './components/training/TrainingDialog';
import CategoryDialog from './components/CategoryDialog';
import ProductDialog from './components/ProductDialog';
import CleanerDialog from './components/CleanerDialog';
import ManagerDialog from './components/ManagerDialog';
import ObjectDialog from './components/ObjectDialog';

const DialogView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return <>
        {sdk.currentDialog.id === 'order' && <OrderDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'editorder' && <OrderEditDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'editfolder' && <EditFolderDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'edittraining' && <EditTrainingDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'category' && <CategoryDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'product' && <ProductDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'cleaner' && <CleanerDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'manager' && <ManagerDialog sdk={sdk} />}
        {sdk.currentDialog.id === 'object' && <ObjectDialog sdk={sdk} />}
    </>
});

export default DialogView;